import { render, staticRenderFns } from "./ManifestacaoAnexosLista.vue?vue&type=template&id=73943e74&scoped=true&"
import script from "./ManifestacaoAnexosLista.vue?vue&type=script&lang=js&"
export * from "./ManifestacaoAnexosLista.vue?vue&type=script&lang=js&"
import style0 from "@/styles/manifestacao.scss?vue&type=style&index=0&id=73943e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73943e74",
  null
  
)

export default component.exports